import Headroom from 'headroom.js';

(function() {
  "use strict";

  angular.module("PrintixUtils", [])

    .service('TemplateResolver', ['$injector', function ($injector) {
      let manifest = null;
  
      this.getTemplateUrl = function (templateUrl) {
          if (!manifest) {
              // Lazily inject $http to avoid circular dependency
              const $http = $injector.get('$http');
              return $http.get('./asset-manifest.json').then(response => {
                  manifest = response.data;
                  return manifest[templateUrl] || templateUrl;
              });
          }
          return Promise.resolve(manifest[templateUrl] || templateUrl);
      };
    }])

    .factory('templateCacheBusterInterceptor', ['$q', 'TemplateResolver', function ($q, TemplateResolver) {
      const cacheBuster = `v=${__webpack_hash__ || Date.now()}`;
  
      // List of templates to exclude from appending ?v=hash
      const excludedTemplates = [
          'list.html',
          'folder.html',
          'file.html',
          'tree.html',
          'site.html',
          'rzSliderTpl.html',
          'select.tpl.html',
          'match.tpl.html',
          'choices.tpl.html',
          'toast.html'
      ];
  
      return {
          request: function (config) {
              if (config.url.endsWith('.html') && !config.url.includes(`v=`)) {
                  
                    const isExcluded = excludedTemplates.some(template => {
                      return config.url.split('/').pop().includes(template);
                    });
                  
                  if (isExcluded) {
                      return config; 
                  }
  
                  return TemplateResolver.getTemplateUrl(config.url).then(resolvedUrl => {
                      const separator = resolvedUrl.includes('?') ? '&' : '?';
                      config.url = `${resolvedUrl}${separator}${cacheBuster}`;
                      return config;
                  });
              }
              return config;
          },
          responseError: function (rejection) {
              return $q.reject(rejection);
          }
      };
  }])

    .filter("containsUppercaseAndLowerCase", function() {
      return function(input) {
        if (angular.lowercase(input) !== input &&
          angular.uppercase(input) !== input) {
          return true;
        } else {
          return false;
        }
      };
    })

    .directive("goToUrl", ["$window", "$location", "$parse",
      function($window, $location, $parse) {
        return function(scope, element, attrs) {
          element.bind("click", function() {
            scope.$apply(function() {
              var url = attrs.goToUrl.split(" ")[0];
              var urlParams = $parse(attrs.goToUrlParams)(scope);
              if (url) {
                if (url.indexOf("http") > -1) {
                  if (urlParams) {
                    $window.open(url).search(urlParams);
                  } else {
                    $window.open(url);
                  }
                } else {
                  if (urlParams) {
                    $location.path(url).search(urlParams);
                  } else {
                    $location.path(url);
                  }
                }
              }
            });
          });
        };
      }
    ])

    .directive("addRootClass", function() {
      return {
        restrict: "A",
        scope: {
          classes: "=addRootClass"
        },
        link: function(scope, element, attributes) {
          document.documentElement.classList.add(scope.classes);
          scope.$on("$destroy", function() {
            document.documentElement.classList.remove(scope.classes);
          });
        }
      };
    })

    .directive("autoResizeMenu", ["Utils", function(Utils) {
      return {
        restrict: "A",
        link: function(scope, element, attributes) {
          angular.element('.navbar .dropdown').on('shown.bs.dropdown', function() {
            Utils.adjustMenuDropDowns();
          });

          var resizeTimer;

          angular.element(window).on('resize', function(e) {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
              Utils.adjustMenuDropDowns();
            }, 250);
          });
        }
      };
    }])

    .directive("headroom", function() {
      return {
        restrict: "C",
        scope: {
          toleranceUp: "=toleranceUp",
          toleranceDown: "=toleranceDown"
        },
        link: function(scope, element, attributes) {
          var headroom = new Headroom(document.querySelector(".headroom"), {
            tolerance: {
              down: scope.toleranceDown,
              up: scope.toleranceUp
            }
          });
          headroom.init();

        }
      };
    })

    .directive("tooltipTitle", ["$filter", "$translate", "$timeout",
      function($filter, $translate, $timeout) {
        return {
          restrict: "A",
          scope: {
            tooltipTitle: "=tooltipTitle"
          },
          link: function(scope, element, attributes) {
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              element.tooltip("destroy");
              if (angular.element("html").hasClass("no-touchevents")) {
                $timeout(function() {
                  var tranlatedTitle = $filter("translate")(scope.tooltipTitle);
                  if (tranlatedTitle === scope.tooltipTitle) {
                    tranlatedTitle = '';
                  }
                  element.tooltip({title: tranlatedTitle});
                }, 300);
              }
            });
          }
        };
      }
    ])

    .directive("confirmOnExit", ["$window", "$filter", "$translate", "$ngBootbox", "$location",
      function($window, $filter, $translate, $ngBootbox, $location) {
        return {
          link: function(scope, elem, attrs) {
            var message = "";
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              message = $filter("translate")("DiscardChanges");
            });
            $window.onbeforeunload = function() {
              var form = scope[attrs.name];
              if (form) {
                if (form.$dirty) {
                  return message;
                }
              }
            };
            scope.$on("$locationChangeStart", function(event, next, current) {
              var form = scope[attrs.name];
              if (form) {
                if (form.$dirty) {
                  event.preventDefault();
                  $ngBootbox.confirm(message).then(function() {
                    form.$dirty = false;
                    $location.path(next.substring($location.absUrl().length - $location.url().length));
                  });
                }
              }
            });
          }
        };
      }
    ])

    .directive("preventFormDualSubmit", function() {
      return {
        restrict: "A",
        scope: {
          form: "=preventFormDualSubmit"
        },
        link: function(scope, element, attributes) {
          if (!scope.form.__customProperties) {
            scope.form.__customProperties = {};
          }
          scope.form.__customProperties.waitingForAnswer = false;
          var btn = angular.element(element);
          scope.$watch(function() {
            return scope.form.__customProperties;
          }, function() {
            if (scope.form.__customProperties &&
              scope.form.__customProperties.waitingForAnswer) {
              btn.addClass("disabled");
              btn.attr("disabled", "disabled");
            } else {
              btn.removeClass("disabled");
              btn.attr("disabled", null);
            }
          }, true);
        }
      };
    })

    .directive("ngIndeterminate", function() {
      return {
        restrict: "A",
        scope: {
          ngIndeterminate: "=ngIndeterminate"
        },
        link: function(scope, element, attributes) {
          scope.$watch(function() {
            return scope.ngIndeterminate;
          }, function() {
            if (attributes["id"]) {
              var checkbox = document.getElementById(attributes["id"]);
              if (checkbox) {
                checkbox.indeterminate = scope.ngIndeterminate;
              } else {
                throw "ngIndeterminate: checkbox is not found";
              }
            } else {
              throw "ngIndeterminate: id attribute is required";
            }
          });
        }
      };
    })

    .directive("addBootstrapPopOver", ["$translate", "$timeout", "$filter",
      function($translate, $timeout, $filter) {
        return {
          restrict: "A",
          scope: {
            addBootstrapPopOver: "=addBootstrapPopOver"
          },
          link: function(scope, element, attributes) {
            scope.$watch(function() {
              return $translate.use();
            }, function() {
              element.popover("destroy");
              $timeout(function() {
                element.popover({
                  trigger: "hover",
                  html: true,
                  title: $filter("translate")(scope.addBootstrapPopOver)
                });
              }, 300);
            });
          }
        };
      }
    ])

    .service("Utils", ["$rootScope", "$filter", "$translate", "$location", "USER_ROLES", "URLS",
      function($rootScope, $filter, $translate, $location, USER_ROLES, URLS) {

        this.evalJs = function(string) {
          if (string) {
            return eval("(function(){" + string + "}())");
          } else {
            throw "Utils.evalJs: string is missing";
          }
        };

        this.objectPropertiesCheck = function(obj, arr, checkIfDefined) {
          if (!obj || !arr) {
            return false;
          }
          var i = 0,
            length = arr.length,
            arrElem = null;
          for (; i < length; i++) {
            arrElem = arr[i].split(".");
            if (Array.isArray(arrElem) && arrElem.length > 1) {
              if (!this.objectPropertiesCheck(obj[arrElem[0]], [arrElem.slice(1, arrElem.length).join(".")])) {
                return false;
              }
            } else {
              if (!obj || !obj.hasOwnProperty(arrElem[0])) {
                return false;
              }
              if (checkIfDefined && angular.isUndefined(obj[arrElem])) {
                return false;
              }
            }
          }
          return true;
        };

        this.isObjectEmpty = function(obj) {
          return angular.equals({}, obj);
        };

        this.getObjectsDifferencesForPatching = function(objectOriginal, objectChanged) {
          if (objectOriginal && objectChanged) {
            var arrayWithPatchingObjects = jsonpatch.compare(objectOriginal, objectChanged);
            //removes any _link patching from the object array
            for (var i = arrayWithPatchingObjects.length - 1; i >= 0; i--) {
              if (arrayWithPatchingObjects[i].path.indexOf("_link") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("version") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("_embedded") !== -1 ||
                arrayWithPatchingObjects[i].path.indexOf("$$hashKey") !== -1) {
                arrayWithPatchingObjects.splice(i, 1);
              }
            }
            //fix hack for adding element in array at the last position
            angular.forEach(arrayWithPatchingObjects, function(obj) {
              var objectPathSplitted = obj.path.split("/");
              if (obj.op === "add" &&
                objectPathSplitted.length > 1 && !isNaN(+objectPathSplitted[objectPathSplitted.length - 1]) &&
                angular.isNumber(+objectPathSplitted[objectPathSplitted.length - 1])) {
                objectPathSplitted[objectPathSplitted.length - 1] = "-";
              }
              obj.path = objectPathSplitted.join("/");
            });
            //fix hack for adding element in array at the last position
            return arrayWithPatchingObjects;
          } else {
            throw "Utils.getObjectsDifferencesForPatching: objectOriginal or objectChanged are missing";
          }
        };


        // Check if dropdowns exceed the device viewport to prevent menu items in long dropdowns
        // from being inaccessible. This occurs because of the fixed header.
        this.adjustMenuDropDowns = function() {
          var overflow_css_class = "dropdown-menu--compact";
          var dropDowns = angular.element(".navbar .dropdown-menu");

          // always add overflow by default to be able to check if the
          // scroll-height exceeds the dropdown height
          dropDowns.addClass(overflow_css_class);

          // run over all dropdowns and check if we need to remove the overflow
          dropDowns.each(function(index, dropDown) {
            var dropDown = angular.element(dropDown);
            var toggle = false;

            // If the scroll-height exceeds the innerheight have a dropdown
            // overflow situation
            if ((dropDown.find('ul')[0] &&
                dropDown.find('ul')[0].scrollHeight > dropDown.innerHeight())) {
              toggle = true;
            }
            dropDown.toggleClass(overflow_css_class, toggle);
          });
        };
      }
    ])

    .service("PageTitleManager", ["$rootScope", "$location", "$filter",
      function($rootScope, $location, $filter) {
        $rootScope.$watch(function() {
          return $location.path();
        }, function() {
          var regExUUIDCheck = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
          var pathSplit = $location.path().split("?")[0].split("/").filter(Boolean);
          if (pathSplit && pathSplit.length > 0) {
            if (pathSplit[pathSplit.length - 1].match(regExUUIDCheck)) {
              $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 2];
            } else {
              var translation = $filter("translate")(pathSplit[pathSplit.length - 1]);
              if (translation !== pathSplit[pathSplit.length - 1] || pathSplit.length < 2) {
                $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 1];
              } else {
                $rootScope.currentUrl = "/" + pathSplit[pathSplit.length - 2];
              }
            }
          }
        });
      }
    ])

    .service("AutoCloseModelOnNavChange", ["$rootScope",
      function($rootScope) {
        $rootScope.$on("$locationChangeStart", function() {
          angular.element("body").removeClass("modal-open");
          angular.element(".modal-backdrop").remove();
        });
      }
    ])

    .service("PrintixRequestHeaderManager", ["$translate", "$filter",
      function($translate, $filter) {
        return {
          "request": function(config) {
            if (config.url.indexOf(".html") < 0 && config.url.indexOf(".js") < 0) {
              if (!config.headers) {
                config.headers = {};
              }
              if (!config.headers["Content-Type"]) {
                config.headers["Content-Type"] = "application/json";
                //if the request method is PATCH - change the Content-Type header to the PATCH header
                if ($filter("lowercase")(config.method) === "patch") {
                  config.headers["Content-Type"] = "application/json-patch+json";
                }
              }

              //add Accept-Language header to all requests
              config.headers["Accept-Language"] = $translate.use();
            }
            return config;
          }
        };
      }
    ])

    .service("ArrayPrototypes", ["$filter", "Utils", function($filter, Utils) {
      var elementRequiredProperties = ["info", "info._links", "info._links.self", "info._links.self.href"];

      Array.prototype.add = function(element, ignoreDuplicateCheck) {
        if (element !== null) {
          if (Utils.objectPropertiesCheck(element, elementRequiredProperties)) {
            if (!this.contains({
                info: {
                  _links: {
                    self: {
                      href: element.info._links.self.href
                    }
                  }
                }
              }) || ignoreDuplicateCheck) {
              this.push(element);
            } else {
              console.log("the element already exists");
            }
          } else {
            if (!this.contains(element) || ignoreDuplicateCheck) {
              this.push(element);
            } else {
              console.log("the element already exists");
            }
          }
        } else {
          throw "Array.prototype.add: element is missing ";
        }
      };

      Array.prototype.addAll = function(array) {
        if (array) {
          this.push.apply(this, array);
        } else {
          throw "Array.prototype.addAll: array is missing";
        }
      };

      Array.prototype.remove = function(element) {
        var indexOfElement = this.indexOf(element);
        if (indexOfElement > -1) {
          this.splice(indexOfElement, 1);
        }
      };

      Array.prototype.removeWith = function(criteria) {
        var array = this;
        angular.forEach(this.findAllElements(criteria), function(element) {
          array.remove(element);
        });
      };

      Array.prototype.contains = function(criteria) {
        if (this.findAllElements(criteria).length > 0) {
          return true;
        } else {
          return false;
        }
      };

      Array.prototype.findElement = function(criteria, notStrict) {
        if (JSON.stringify(criteria) && JSON.stringify(criteria).indexOf("href") > -1) {
          return $filter("filter")(this, domainlessObjectFilter(criteria), notStrict ? false : true)[0];
        } else {
          return $filter("filter")(this, criteria, notStrict ? false : true)[0];
        }
      };

      Array.prototype.findAllElements = function(criteria, notStrict) {
        if (JSON.stringify(criteria) && JSON.stringify(criteria).indexOf("href") > -1) {
          return $filter("filter")(this, domainlessObjectFilter(criteria), notStrict ? false : true);
        } else {
          return $filter("filter")(this, criteria, notStrict ? false : true);
        }
      };

      function domainlessObjectFilter(criteria) {
        return function(item) {
          var itemCopy = angular.copy(item);
          var criteriaCopy = changeCritariaURLDomain(itemCopy, angular.copy(criteria));
          return $filter("filter")([itemCopy], criteriaCopy, true).length > 0;
        }
      }

      function changeCritariaURLDomain(item, criteria) {
        var criteriaCopy = angular.copy(criteria);
        if (item && JSON.stringify(criteriaCopy) && JSON.stringify(criteriaCopy).indexOf("href") > -1) {
          var itemCopy = angular.copy(item);
          if (itemCopy.info) {
            itemCopy = itemCopy.info;
          }
          var domainPrefixItem = null;
          if (itemCopy._links && itemCopy._links.self && itemCopy._links.self.href) {
            domainPrefixItem = itemCopy._links.self.href.split("/tenants")[0];
          } else if (itemCopy.href) {
            domainPrefixItem = itemCopy.href.split("/tenants")[0];
          } else {
            throw "changeCritariaURLDomain: itemCopy does not have _links.self.href or href";
          }
          var criteriaCopyAsString = JSON.stringify(criteriaCopy);
          var criteriaCopyAsStringCopy = angular.copy(criteriaCopyAsString);
          var domainPrefixCriteria = criteriaCopyAsStringCopy.substring(criteriaCopyAsStringCopy.lastIndexOf('https://'), criteriaCopyAsStringCopy.lastIndexOf("/tenants"));
          criteriaCopyAsString = criteriaCopyAsString.replace(domainPrefixCriteria, domainPrefixItem);
          criteriaCopy = JSON.parse(criteriaCopyAsString);
        }
        return criteriaCopy
      }
    }]);
})();